module.exports = __webpack_public_path__ + "img/menu-banner-stepp-assist.5c1f7a6f.png";